import "./styles.scss"

import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Slider from "react-slick"
import LazyLoad from "react-lazy-load"

import LightboxYarl from "../../../components/LightboxYarl"

const slider = {
  className: "csr-gallery__slider",
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

const Gallery = ({ year = '2026' }) => {
  const data = useStaticQuery(graphql`
    query GalleryQuery {
      allFile(filter: {relativeDirectory: {regex: "/^krakow-sky-run\\/gallery(\\/.*)?$/"}}) {
        nodes {
          childImageSharp {
            original {
              src
            }
          }
          name
          relativePath
        }
      }
    }
  `)

  const [lightboxIndex, setLightboxIndex] = useState(null)

  const images = data?.allFile?.nodes?.filter(item => item.relativePath.startsWith(`krakow-sky-run/gallery/${year}`))?.sort((a, b) => {
    const intA = parseInt(a.name);
    const intB = parseInt(b.name);

    return intA - intB;
  }) || []

  if (!(images?.length > 0)) return null

  const lightboxImages = images.map(item => ({
    src: item.childImageSharp?.original?.src,
  }))

  return (
    <>
      <section className="csr-gallery">
        {images?.length > 0 && (
          <Slider {...slider}>
            {images.map((item, index) => (
              <div className="csr-gallery__slider-item" key={index}>
                <button type="button" onClick={() => setLightboxIndex(index)}>
                  <LazyLoad>
                    <img src={item.childImageSharp?.original.src} alt="" />
                  </LazyLoad>
                </button>
              </div>
            ))}
          </Slider>
        )}
      </section>

      <LightboxYarl
        slides={lightboxImages}
        index={lightboxIndex}
        setIndex={setLightboxIndex}
        isOpen={lightboxIndex !== null}
        onClose={() => setLightboxIndex(null)}
      />
    </>
  )
}

export default Gallery
